// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Accessory } from './atoms';
import { TilesColumn, TileSelect } from '../tileSelect';
import { makeGetAccessories } from '../../../../store/configuration';
import type { Accessory as AccessoryType } from '../../../../types/pdb';

type StateProps = {|
  accessories: Array<AccessoryType>,
|};

type Props = StateProps;

const Accessories = ({ accessories }: Props) => {
  const accessoryTiles = accessories && accessories.map(accessory => (
    <Accessory
      accessory={accessory}
      blockCount={accessories.length}
      key={`accessory-${accessory.id}`}
    />
  ));

  return (
    <TileSelect>
      <TilesColumn>{accessoryTiles}</TilesColumn>
      <TilesColumn>{accessoryTiles}</TilesColumn>
    </TileSelect>
  );
};

// @TODO Cannot return function because function [1] is not an object.
const makeMapStateToProps = (state: any): StateProps => {
  const getAccessories = makeGetAccessories();
  return {
    accessories: getAccessories(state),
  };
};

export default connect<any, void, StateProps, any, any, any>(makeMapStateToProps)(Accessories);
